import React from "react"; // React의 상태와 생명주기 관련 훅
import { Link, useNavigate } from "react-router-dom"; // 페이지 이동(Link와 useNavigate) 관련 라이브러리
import "assets/scss/pages/loginPage.scss"; // 로그인 모달에 대한 스타일
import LoginForm from "components/form/LoginForm";
import SubHeader from "components/common/SubHeader";

const LoginModal = () => {
    const navigate = useNavigate();
    return (
        <>
            <SubHeader
                title="로그인"
                goback={() => {
                    navigate("/", { replace: true });
                }}
            />
            <div className="login-modal-content">
                <div className="login-logo">
                    <img
                        src={`${process.env.PUBLIC_URL}/images/logo.png`}
                        alt="DEEPS"
                        width={118}
                    />
                </div>
                <LoginForm />
                <div className="modal-links">
                    <Link to="/find-id" className="find-id">
                        아이디/비밀번호 찾기
                    </Link>
                    <span className="link-separator">|</span>
                    <Link to="/signup" className="signup">
                        회원가입
                    </Link>
                </div>
            </div>
        </>
    );
};

export default LoginModal; // LoginModal 컴포넌트를 외부에서 사용할 수 있도록 내보냄
